import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import Tours from "./pages/Tours";
import Bookings from "./pages/Bookings";
import GuideDashboard from "./pages/guide/Dashboard";
import CoordinatorDashboard from "./pages/coordinator/Dashboard";
import Login from "./pages/Login";
import GuideLayout from "./pages/guide/GuideLayout";
import CoordinatorLayout from "./pages/coordinator/CoordinatorLayout";
import Guides from "./pages/Guides";
import GuideAvailability from "./pages/GuideAvailability";
import Email from "./pages/Email";
import Users from "./pages/Users";
import RequirePermission
    from "./components/RequirePermission";
import TourDetails from "./pages/guide/TourDetails";
import CoordinatorTourDetails from "./pages/coordinator/TourDetails";
import Revenue from "./pages/Revenue";

function App() {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token");

  const storedUser =
    localStorage.getItem("user") ||
    sessionStorage.getItem("user");

  const user = storedUser ? JSON.parse(storedUser) : null;

  return (
    <BrowserRouter>
      <Routes>

       {/* ROOT REDIRECT */}
<Route
  path="/"
  element={
    !token ? (
      <Navigate to="/login" replace />
    ) : user?.role === "guide" ? (
  <Navigate to="/guide" replace />
) : user?.role === "coordinator" ? (
  <Navigate to="/coordinator" replace />
) : (
      <Navigate to="/admin/dashboard" replace />
    )
  }
/>

        {/* LOGIN */}
        <Route path="/login" element={<Login />} />

        {/* ADMIN PROTECTED */}
        <Route
    path="/admin/dashboard"
    element={
        <RequirePermission
            permission="view_dashboard"
        >
            <Dashboard />
        </RequirePermission>
    }
/>

        <Route
    path="/admin/tours"
    element={
        <RequirePermission
            permission="manage_tours"
        >
            <Tours />
        </RequirePermission>
    }
/>

        <Route
    path="/admin/bookings"
    element={
        <RequirePermission
            permission="manage_bookings"
        >
            <Bookings />
        </RequirePermission>
    }
/>

        <Route
    path="/admin/users"
    element={
        <RequirePermission
            permission="manage_users"
        >
            <Users />
        </RequirePermission>
    }
/>

        <Route
    path="/admin/email"
    element={
        <RequirePermission
            permission="manage_email"
        >
            <Email />
        </RequirePermission>
    }
/>
        
        <Route
    path="/admin/guides"
    element={
        <RequirePermission
            permission="manage_guides"
        >
            <Guides />
        </RequirePermission>
    }
/>

       <Route
    path="/admin/guide-availability"
    element={
        <RequirePermission
            permission="manage_availability"
        >
            <GuideAvailability />
        </RequirePermission>
    }
/>

<Route
    path="/admin/revenue"
    element={
        <RequirePermission permission="view_revenue">
            <Revenue />
        </RequirePermission>
    }
/>

<Route
    path="/admin/tour/:id"
    element={
        <RequirePermission permission="manage_tours">
            <TourDetails />
        </RequirePermission>
    }
/>



      {/* GUIDE */}
<Route path="/guide/*" element={<GuideLayout />} />
<Route path="/guide/dashboard" element={<GuideDashboard />} />
<Route
    path="/guide/tour/:id"
    element={<TourDetails />}
/>

{/* COORDINATOR */}
<Route path="/coordinator/*" element={<CoordinatorLayout />} />
<Route
    path="/coordinator/dashboard"
    element={<CoordinatorDashboard />}
/>
<Route
    path="/coordinator/tour/:id"
    element={<CoordinatorTourDetails />}
/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;